//--------------------| Objeto vacio  |--------------------
export let paqueteVacio = {
    id: null,
    nombrePaquete: '',
    noMaquinas: 0,
    noUsuarios: 0,
    vigencia: '',
    idEstatus: 1
}